"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Header = /*#__PURE__*/function () {
  function Header(component) {
    (0, _classCallCheck2["default"])(this, Header);
    this.dom = {
      $window: window,
      $component: component,
      $drawer: component.querySelector('.js-header-drawer'),
      $currencySwitcher: Array.from(document.querySelectorAll('.js-header-currency-switcher')),
      $subnav: document.querySelector('.js-header-subnav'),
      $subnavTab: Array.from(document.querySelectorAll('.js-header-subnav-tab')),
      $drawerScroll: component.querySelector('.js-header-scroll-container'),
      $drawerToggles: Array.from(component.querySelectorAll('.js-header-toggle-drawer')),
      $hoverItems: Array.from(component.querySelectorAll('.js-header-hover.js-header-item-with-levels-trigger')),
      $itemWithChildren: component.querySelector('.js-header-item-with-levels'),
      $itemWithChildrenTrigger: Array.from(component.querySelectorAll('.js-header-item-with-levels-trigger')),
      $spacer: component.querySelector('.js-header-spacer'),
      $fixedHeader: component.querySelector('.js-header-offset'),
      $hamburger: component.querySelector('.Header__toggle-drawer'),
      $mobileItemsToHide: component.querySelectorAll(".Header__mobile-right .Header__mobile-item:not(.Header__mobile-item--hamburger)"),
      $mobileNavAccordionHeadings: component.querySelectorAll(".Header__drawer-heading--accordionHeading")
    };
    this.state = {
      open: false,
      animating: false,
      openDuration: 500,
      closeDuration: 500,
      offsetHeight: component.offsetHeight * 2,
      activeClass: 'Header--has-drawer',
      scrolled: false,
      scrolledClass: 'Header--is-scrolled',
      bodyWhiteHeaderClass: 'Body--header-white-bg',
      bodyWhiteHeaderTopClass: 'Body--header-white-font--top',
      bodyBlackHeaderTopClass: 'Body--header-black-font--top',
      bodyHeaderTopClass: false,
      scrollTarget: window.innerHeight / 4 * 1.5,
      scrollPosition: 0,
      scrollLimitValue: 1,
      scrollDirection: false,
      allowScroll: true,
      whiteHeader: false,
      supportsNativeSmoothScroll: 'scrollBehavior' in document.documentElement.style // itemWithChildrenOpen: false

    };
    this.keydownHandler = this.onKeydown.bind(this);
    this.toggleHandler = this.toggleNavigation.bind(this);
    this.mouseenterHandler = this.mouseenter.bind(this);
    this.mouseleaveHandler = this.mouseleave.bind(this);
    this.mouseenterItemHandler = this.mouseenterItem.bind(this);
    this.mouseleaveItemHandler = this.mouseleaveItem.bind(this);
    this.routeFinishHandler = this.closeNavigation.bind(this);
    this.scrollHandler = this.checkScrollPosition.bind(this);
    this.miniCartOpenHandler = this.setMiniCartStateOpen.bind(this);
    this.miniCartCloseHandler = this.setMiniCartStateClose.bind(this);
    this.currencyHandler = this.setCurrency.bind(this);
    this.updatePadHandler = this.updatePad.bind(this);
    this.toggleAccordionHandler = this.toggleAccordion.bind(this);
    this.padBody();
    this.mount();
  }

  (0, _createClass2["default"])(Header, [{
    key: "mount",
    value: function mount() {
      var _this = this;

      var dom = this.dom,
          state = this.state;
      console.log('Header : mount', this);
      dom.$drawerToggles.forEach(function ($toggle) {
        return $toggle.addEventListener('click', _this.toggleHandler);
      });

      if (dom.$itemWithChildrenTrigger) {
        dom.$itemWithChildrenTrigger.forEach(function ($el) {
          if ($el.classList.contains('Header__action')) {
            $el.addEventListener('click', _this.openItemWithChildren);
          }

          $el.addEventListener('mouseenter', _this.mouseenterItemHandler);
          $el.addEventListener('mouseleave', _this.mouseleaveItemHandler);
        });
      }

      document.addEventListener('keydown', this.keydownHandler);
      document.addEventListener('router:finish', this.routeFinishHandler);
      document.addEventListener('scroll', this.scrollHandler, true);
      document.addEventListener('minicart:open', this.miniCartOpenHandler);
      document.addEventListener('minicart:close', this.miniCartCloseHandler);
      document.addEventListener('updatePad', this.updatePadHandler);
      dom.$currencySwitcher.forEach(function (el) {
        return el.addEventListener('change', _this.currencyHandler);
      });

      if (document.body.classList.contains(state.bodyWhiteHeaderClass)) {
        if (document.body.classList.contains(state.bodyWhiteHeaderTopClass)) {
          state.bodyHeaderTopClass = state.bodyWhiteHeaderTopClass;
        } else {
          state.bodyHeaderTopClass = state.bodyBlackHeaderTopClass;
        }

        state.whiteHeader = true;
        dom.$component.addEventListener('mouseenter', this.mouseenterHandler);
        dom.$component.addEventListener('mouseleave', this.mouseleaveHandler);
      }

      if (dom.$mobileNavAccordionHeadings) {
        dom.$mobileNavAccordionHeadings.forEach(function (el) {
          el.addEventListener('click', _this.toggleAccordionHandler);
        });
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var _this2 = this;

      var self = this;
      var dom = this.dom,
          state = this.state;
      console.log('Header : unmount', this);
      dom.$drawerToggles.forEach(function ($toggle) {
        return $toggle.removeEventListener('click', _this2.toggleHandler);
      });

      if (dom.$itemWithChildrenTrigger) {
        dom.$itemWithChildrenTrigger.forEach(function ($el) {
          if ($el.classList.contains('Header__action')) {
            $el.removeEventListener('click', _this2.openItemWithChildren);
          }

          $el.removeEventListener('mouseenter', _this2.mouseenterItemHandler);
          $el.removeEventListener('mouseleave', _this2.mouseleaveItemHandler);
        });
      }

      document.removeEventListener('keydown', this.keydownHandler);
      document.removeEventListener('route:finish', this.routeFinishHandler);
      document.removeEventListener('scroll', this.scrollHandler, true);
      document.removeEventListener('minicart:open', this.miniCartOpenHandler);
      document.removeEventListener('minicart:close', this.miniCartCloseHandler);
      dom.$currencySwitcher.forEach(function (el) {
        return el.removeEventListener('change', _this2.currencyHandler);
      });

      if (document.body.classList.contains(state.bodyWhiteHeaderClass)) {
        state.whiteHeader = false;
        dom.$component.removeEventListener('mouseenter', this.mouseenterHandler);
        dom.$component.removeEventListener('mouseleave', this.mouseleaveHandler);
      }

      if (dom.$mobileNavAccordionHeadings) {
        dom.$mobileNavAccordionHeadings.forEach(function (el) {
          el.removeEventListener('click', _this2.toggleAccordionHandler);
        });
      }
    }
  }, {
    key: "addPad",
    value: function addPad() {
      var scroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var timeout = arguments.length > 1 ? arguments[1] : undefined;
      var dom = this.dom,
          state = this.state;
      setTimeout(function () {
        dom.$spacer.style.paddingBottom = dom.$fixedHeader.getBoundingClientRect().height + 'px';
        scroll == true ? window.scroll(0, 0) : '';
      }, timeout);
    }
  }, {
    key: "padBody",
    value: function padBody() {
      var dom = this.dom,
          state = this.state;

      if (dom.$fixedHeader) {
        this.addPad(false, 300);
        window.addEventListener('resize', this.addPad(false, 300));
      }
    }
  }, {
    key: "updatePad",
    value: function updatePad(event) {
      var dom = this.dom,
          state = this.state;
      console.log('Header : updatePad', this, event);
      this.addPad(false, 10);
    }
  }, {
    key: "checkScrollPosition",
    value: function checkScrollPosition() {
      var dom = this.dom,
          state = this.state;
      var lastScroll = state.scrollPosition;
      var scrollY = window.scrollY;

      if (state.allowScroll) {
        if (state.whiteHeader && scrollY < state.scrollLimitValue && !document.body.classList.contains(state.bodyHeaderTopClass)) {
          document.body.classList.add(state.bodyHeaderTopClass);
        }

        if (!state.scrolled && scrollY > state.scrollTarget) {
          console.log('Header : checkScrollPosition : scrolled', this);
          dom.$component.classList.add(state.scrolledClass);
          setTimeout(function () {
            document.body.classList.remove(state.bodyHeaderTopClass);
          }, 150);
          this.state.scrolled = true;
        }

        if (state.scrolled && scrollY <= state.scrollTarget) {
          console.log('Header : checkScrollPosition : !scrolled', this);
          dom.$component.classList.remove(state.scrolledClass);
          state.scrolled = false;
        }

        if (scrollY > lastScroll && state.scrollDirection !== 'down') {
          console.log('Header : checkScrollPosition : scrolling Down', this);
          state.scrollDirection = 'down';

          if (state.scrolled) {
            dom.$component.classList.add(state.scrolledClass);
          }
        }

        if (scrollY < lastScroll && state.scrollDirection !== 'up') {
          console.log('Header : checkScrollPosition : scrolling Up', this);
          state.scrollDirection = 'up';

          if (state.scrolled) {
            dom.$component.classList.remove(state.scrolledClass);
          }
        }
      }

      state.scrollPosition = scrollY;
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      var state = this.state;
      console.log('Header : onKeydown', this, event);
      var escape = event.keyCode === 27;

      if (state.open && escape) {
        this.closeNavigation();
      }
    }
  }, {
    key: "setCurrency",
    value: function setCurrency(event) {
      var state = this.state;
      console.log('Header : setCurrency', this);
      window.location = event.currentTarget.value;
    }
  }, {
    key: "toggleNavigation",
    value: function toggleNavigation() {
      var state = this.state;
      console.log('Header : toggleNavigation', this);

      if (state.open) {
        this.closeNavigation();
      } else {
        this.openNavigation();
      }
    }
  }, {
    key: "openNavigation",
    value: function openNavigation() {
      var _this3 = this;

      var dom = this.dom,
          state = this.state;
      console.log('Header : openNavigation', this);

      if (!state.animating) {
        state.animating = true;
        dom.$drawer.setAttribute('aria-hidden', 'false');
        dom.$drawer.setAttribute('aria-expanded', 'true');
        setTimeout(function () {
          if (state.supportsNativeSmoothScroll) {
            dom.$drawerScroll.scrollTo(0, 0);
          }

          dom.$component.classList.add(state.activeClass);
          dom.$hamburger.classList.add('is-active');
          dom.$mobileItemsToHide.forEach(function ($el) {
            return $el.classList.add('inactive');
          });
        }, 25);
        setTimeout(function () {
          state.open = true;
          state.allowScroll = false;
          state.animating = false;

          _this3.resetScroll();
        }, state.openDuration);
      }
    }
  }, {
    key: "closeNavigation",
    value: function closeNavigation() {
      var dom = this.dom,
          state = this.state;
      console.log('Header : closeNavigation', this);

      if (!state.animating) {
        state.animating = true;
        setTimeout(function () {
          dom.$component.classList.remove(state.activeClass);
          dom.$hamburger.classList.remove('is-active');
          dom.$mobileItemsToHide.forEach(function ($el) {
            return $el.classList.remove('inactive');
          });
        }, 25);
        setTimeout(function () {
          dom.$drawer.setAttribute('aria-hidden', 'true');
          dom.$drawer.setAttribute('aria-expanded', 'false');
          state.open = false;
          state.allowScroll = true;
          state.animating = false;
        }, state.closeDuration);
      }
    }
  }, {
    key: "setMiniCartStateOpen",
    value: function setMiniCartStateOpen(event) {
      var dom = this.dom,
          state = this.state;
      console.log('Header : setMiniCartStateOpen', this, event);
      state.allowScroll = false;

      if (state.scrolled) {
        this.resetScroll();
      }
    }
  }, {
    key: "setMiniCartStateClose",
    value: function setMiniCartStateClose(event) {
      var dom = this.dom,
          state = this.state;
      console.log('Header : setMiniCartStateClose', this, event);
      state.allowScroll = true;
    }
  }, {
    key: "resetScroll",
    value: function resetScroll() {
      var dom = this.dom,
          state = this.state;
      console.log('Header : resetScroll : !scrolled', this);
      dom.$component.classList.remove(state.scrolledClass);
      state.scrolled = false;
    }
  }, {
    key: "openItemWithChildren",
    value: function openItemWithChildren(event) {//event.preventDefault()
    }
  }, {
    key: "mouseenter",
    value: function mouseenter(e) {
      var dom = this.dom,
          state = this.state;

      if (document.body.classList.contains(state.bodyWhiteHeaderTopClass)) {
        document.body.classList.remove(state.bodyWhiteHeaderTopClass);
      }
    }
  }, {
    key: "mouseleave",
    value: function mouseleave(e) {
      var dom = this.dom,
          state = this.state;

      if (state.scrollPosition < state.scrollLimitValue) {
        document.body.classList.add(state.bodyHeaderTopClass);
      }
    }
  }, {
    key: "mouseenterItem",
    value: function mouseenterItem(e) {
      var dom = this.dom,
          state = this.state;
      console.log('Header : mouseenterItem');
      var subnavnumber = e.target.getAttribute('data-subnav-number');
      dom.$subnavTab[subnavnumber].classList.add('active');
      dom.$hoverItems[subnavnumber].classList.add('active');
      dom.$subnav.classList.add('active');
      state.allowScroll = false;

      if (state.scrolled) {
        this.resetScroll();
      }
    }
  }, {
    key: "mouseleaveItem",
    value: function mouseleaveItem(e) {
      var dom = this.dom,
          state = this.state;
      console.log('Header : mouseleaveItem');
      dom.$subnavTab.forEach(function ($el) {
        return $el.classList.remove('active');
      });
      dom.$hoverItems.forEach(function ($el) {
        return $el.classList.remove('active');
      });
      dom.$subnav.classList.remove('active');
      state.allowScroll = true;
    }
  }, {
    key: "toggleAccordion",
    value: function toggleAccordion(e) {
      var state = this.state;
      e.preventDefault();

      if (!state.animating) {
        state.animating = true;
        var accordionWrapper = e.target.closest('.Header__drawer-section--nav');
        var accordionContainer = accordionWrapper.querySelector('.Header__drawer-section-container');
        e.target.closest('.Header__drawer-section--nav').classList.toggle('Header__drawer-section--preopen');

        if (accordionWrapper.classList.contains('Header__drawer-section--open')) {
          accordionContainer.setAttribute('style', 'height:' + accordionContainer.scrollHeight + 'px');
          setTimeout(function () {
            accordionContainer.setAttribute('style', 'height: 0px');
          }, 30);
        } else {
          accordionContainer.setAttribute('style', 'height:' + (accordionContainer.scrollHeight + 12) + 'px');
        }

        setTimeout(function () {
          e.target.closest('.Header__drawer-section--nav').classList.toggle('Header__drawer-section--open');
          accordionContainer.removeAttribute('style');
          state.animating = false;
        }, 300);
      }
    }
  }]);
  return Header;
}();

exports["default"] = Header;